import React, { useState, useEffect } from 'react';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import { BannerMessage, BannerWrapper } from '../../App/styles';
import InfoIcon from './InfoIcon';
import Close from './CloseIcon';

const Banner = ({ bannerMessage, hasTimer, showBanner, closeBannerCb }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(showBanner);
    let timerid;
    if (hasTimer) {
      timerid = setTimeout(() => setIsVisible(false), 10000);
    }
    return () => {
      clearTimeout(timerid);
    };
  }, [showBanner]);

  const onCloseBanner = () => {
    setIsVisible(false);
    if (closeBannerCb) {
      closeBannerCb();
    }
  };

  return (isVisible ?
    (
      <BannerWrapper hasTimer={hasTimer}>
        <InfoIcon />
        <BannerMessage>
          {bannerMessage}
        </BannerMessage>
        <Close onClick={onCloseBanner} />
      </BannerWrapper>
    ) :
    null
  );
};

Banner.propTypes = {
  bannerMessage: PropTypes.node,
  hasTimer: PropTypes.bool,
  showBanner: PropTypes.bool.isRequired,
  closeBannerCb: PropTypes.func,
};
Banner.defaultProps = {
  bannerMessage: null,
  hasTimer: false,
  closeBannerCb: noop,
};

export default Banner;
